import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initSwiper() {

  new Swiper('.swiper', {
    modules: [Navigation],
    watchOverflow: true,
    loop: false,
    centeredSlides: false,
    slideToClickedSlide: true,
    slidesPerView: 1.1,
    breakpoints: {
      768: { slidesPerView: 2.25 },
      1080: { slidesPerView: 3.25 }
    },
    navigation: {
      nextEl: '.swiper--alumni .swiper-button-next',
      prevEl: '.swiper--alumni .swiper-button-prev'
    }
  });
}


initSwiper();
